
import * as fromActions from '../actions/header.actions';
import { HeaderState, StoreAction } from '../../models/rootState.model';

const INITIAL_STATE: HeaderState = {
  backbutton: false,
  enabled: true,
  title: 'Gioco',
  executingButtonEffect: false,
  contextMenuButtonVisible: false,
  loading: false,
  visible: true,
  mainMenu: 'closed',
  sideMenu: 'closed',
  alert_visible: false,
  elevation: 4,
  hideRightButtons: false,
  helpButton: null,
  extraButtons: null
};

export function HeaderReducer(
  state = INITIAL_STATE,
  action: StoreAction
): HeaderState {

  switch (action.type) {
    case fromActions.HEADER_ACTIONS_TYPES.SET_OPTIONS: {
      return {
        ...state,
        ...action.payload
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.BACK_BUTTON_SET: {
      return {
        ...state,
        backbutton: action.payload
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.BACK_BUTTON_CLICKED: {
      return {
        ...state,
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.RESSET: {
      let newState = {
        ...INITIAL_STATE,
        mainMenu: state.mainMenu,
      };

      if (action.payload) {
        newState = {
          ...newState,
          ...action.payload
        };
      }

      return newState;
    }

    case fromActions.HEADER_ACTIONS_TYPES.START_LOADER: {
      return {
        ...state,
        loading: true
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.STOP_LOADER: {
      return {
        ...state,
        loading: false
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.SHOW: {
      return {
        ...state,
        visible: true
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.HIDE: {
      return {
        ...state,
        visible: false
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.SHOW_CONTEXT_MENU_BUTTON: {
      return { ...state, contextMenuButtonVisible: true };
    }

    case fromActions.HEADER_ACTIONS_TYPES.HIDE_CONTEXT_MENU_BUTTON: {
      return { ...state, contextMenuButtonVisible: false };
    }


    case fromActions.HEADER_ACTIONS_TYPES.OPEN_MAIN_MENU: {
      return {
        ...state,
        mainMenu: 'opened'
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.CLOSE_MAIN_MENU: {
      return {
        ...state,
        mainMenu: 'closed'
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.TOGGLE_MAIN_MENU: {
      return {
        ...state,
        mainMenu: state.mainMenu == 'opened' ? 'closed' : 'opened'
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.OPEN_SIDE_MENU: {
      return {
        ...state,
        sideMenu: 'opened'
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.CLOSE_SIDE_MENU: {
      return {
        ...state,
        sideMenu: 'closed'
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.TOGGLE_SIDE_MENU: {
      return {
        ...state,
        sideMenu: state.sideMenu == 'opened' ? 'closed' : 'opened'
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.CLOSE_ALL_MENUS: {
      const st = { ...state };
      if (state.sideMenu == 'opened') { st.sideMenu = 'closed'; }
      if (state.mainMenu == 'opened') { st.mainMenu = 'closed'; }
      if (state.alert_visible) { st.alert_visible = false; }

      return st;
    }

    case fromActions.HEADER_ACTIONS_TYPES.DISABLE: {
      return {
        ...state,
        enabled: false
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.ENABLE: {
      return {
        ...state,
        enabled: true
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.SHOW_ALERTS: {
      return {
        ...state,
        alert_visible: true
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.CLOSE_ALERTS: {
      return {
        ...state,
        alert_visible: false
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.TOGGLE_ALERTS: {
      return {
        ...state,
        alert_visible: !state.alert_visible
      };
    }

    case fromActions.HEADER_ACTIONS_TYPES.SET_ELEVATION: {
      return {
        ...state,
        elevation: action.payload
      };
    }

    default: { return state; }
  }

}
